import { render, staticRenderFns } from "./ToggleDirectProposalBtn.vue?vue&type=template&id=35297239&scoped=true&"
import script from "./ToggleDirectProposalBtn.vue?vue&type=script&lang=js&"
export * from "./ToggleDirectProposalBtn.vue?vue&type=script&lang=js&"
import style0 from "./ToggleDirectProposalBtn.vue?vue&type=style&index=0&id=35297239&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35297239",
  null
  
)

export default component.exports